<lms-document-editor [clientId]="clientId" (onSave)="onSave($event)"> </lms-document-editor>
